import {
	GET_COMMENT,
	CLEAR_COMMENT,
	CREATE_COMMENT,
	UPDATE_COMMENT,
	DELETE_COMMENT
} from "../ActionTypes"

import { checkDupArrayComment } from "../FunctionAction/function.project"
const initialState = {
	comment: [],
	loading: true,
	LastEvaluatedKeyComment: null
}

export default (state = initialState, { type, payload }) => {
	const { comment } = state
	switch (type) {
		case GET_COMMENT + "_FULFILLED":
			return {
				...state,
				comment: checkDupArrayComment(comment, payload.data.getComment.data),
				LastEvaluatedKeyComment: payload.data.getComment.next_token,
				loading: false
			}
		case GET_COMMENT + "_PENDING":
			return { ...state, loading: true }
		case GET_COMMENT + "_REJECTED":
			return { ...state, loading: false }
		case CLEAR_COMMENT:
			return { ...state, comment: [], LastEvaluatedKeyComment: null }
		case CREATE_COMMENT + "_FULFILLED":
			return { ...state, loading: false }
		case CREATE_COMMENT + "_PENDING":
			return { ...state, loading: true }
		case CREATE_COMMENT + "_REJECTED":
			return { ...state, loading: false }
		case UPDATE_COMMENT + "_FULFILLED":
			return { ...state, loading: false }
		case UPDATE_COMMENT + "_PENDING":
			return { ...state, loading: true }
		case UPDATE_COMMENT + "_REJECTED":
			return { ...state, loading: false }
		case DELETE_COMMENT + "_FULFILLED":
			return { ...state, loading: false }
		case DELETE_COMMENT + "_PENDING":
			return { ...state, loading: true }
		case DELETE_COMMENT + "_REJECTED":
			return { ...state, loading: false }
		default:
			return state
	}
}
